/* ------------------------------------------------------------------
   BOOBIE CART - SECOND BRACELET OFFER + COMPLETE-THE-SET STEPPER
   --------------------------------------------------------------------
   1. Offer sync: reads the cart, counts eligible bracelet units and keeps
      a Shopify AUTOMATIC Buy-X-Get-Y discount. There is no code: Shopify
      applies and removes it from the cart contents on its own.
      The SAVING comes from the theme setting via data-sb-amount - never hardcode it
      applied when 2+ are present, removed when fewer. Handles a clash
      with a customer code: applies whichever saves more, says so, and
      offers a one-tap swap. Decision is remembered per cart signature so
      it never loops.
   2. Discount code field in the drawer footer.
   3. Shipping Protection "pre-selected" test variant (section setting).
   4. Complete-the-set stepper: family > finish > size > engraving, adds the
      second bracelet with the exact engraving property contract used by
      custom-engraving.js (Easify cart-transform format), then re-syncs.
      Also edit / add / remove engraving on Signature lines in the bag.
------------------------------------------------------------------ */
(function () {
  // No code. The saving is an automatic discount; this is only used to spot
  // the offer's allocation on a cart line so the drawer can name it.
  // The Shopify discount title must start with "Second" for the drawer to
  // recognise its allocation. Rename it in admin and this stops matching.
  var OFFER_TITLE_MATCH = 'SECOND';
  var OFFER_HANDLES = ['gold-breastfeeding-bracelet', 'silver-breastfeeding-bracelet', 'rose-gold-breastfeeding-bracelet', 'pure-copper-breastfeeding-bracelet', 'minimal-bracelet', 'minimal-bracelet-silver'];
  var SIGNATURE_HANDLES = ['gold-breastfeeding-bracelet', 'silver-breastfeeding-bracelet', 'rose-gold-breastfeeding-bracelet', 'pure-copper-breastfeeding-bracelet'];
  var PROTECTION_VARIANT = 51511546773644;
  var CONFIRM_VALUE = 'I verify my engraving text is correct. I understand customised bracelets are unable to be returned. ';
  var DECISION_KEY = 'bcart-sb-decision';
  var DISPLACED_KEY = 'bcart-sb-displaced';
  var PROTECT_OPTOUT_KEY = 'bcart-protect-optout';

  var syncing = false;
  var lastState = null;

  // While we are measuring discount combinations the cart total is in flux, so
  // the checkout button is held until the cart settles. Without this a fast tap
  // can check out on an intermediate discount state.
  function setBusy(on) {
    document.querySelectorAll('.bcart__checkout').forEach(function (b) {
      if (on) {
        if (!b.dataset.label) b.dataset.label = b.innerHTML;
        b.setAttribute('aria-busy', 'true');
        b.disabled = true;
        b.innerHTML = 'Updating your bag' + '&hellip;';
      } else {
        b.removeAttribute('aria-busy');
        b.disabled = false;
        if (b.dataset.label) { b.innerHTML = b.dataset.label; delete b.dataset.label; }
      }
    });
  }

  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function drawer() { return document.querySelector('[data-bcart]'); }
  // Single source of truth for the saving, set in theme settings and stamped
  // onto the drawer. Hardcoding it here is how the cart ends up promising a
  // number that checkout does not honour.
  // Percentage, applied to the local price. Never a hardcoded dollar figure:
  // prices differ per market and a fixed amount would be wrong everywhere but AU.
  // Two rates: the second Signature and a Minimal paired with a Signature.
  // Each mirrors its own Shopify automatic discount.
  function sbPct(fam) {
    var d = drawer();
    var attr = fam === 'minimal' ? 'data-sb-min-pct' : 'data-sb-pct';
    var p = d && parseFloat(d.getAttribute(attr));
    return (p && p > 0) ? p : (fam === 'minimal' ? 36.85 : 33.34);
  }
  // Shopify truncates the discount to whole cents, so match it exactly or the
  // cart advertises a cent more than checkout gives.
  function sbAmountFor(priceCents, fam) { return Math.floor(priceCents * sbPct(fam) / 100); }
  function sbLive() {
    var d = drawer();
    return !d || d.getAttribute('data-sb-live') !== 'false';
  }

  /* ---------------- money ---------------- */
  function formatMoney(cents) {
    var format = (window.themeVariables && themeVariables.settings && themeVariables.settings.moneyFormat) || '${{amount}}';
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision; thousands = thousands || ','; decimal = decimal || '.';
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }
    var m = format.match(placeholderRegex);
    switch (m ? m[1] : 'amount') {
      case 'amount': value = formatWithDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = formatWithDelimiters(cents, 2, "'", '.'); break;
      default: value = formatWithDelimiters(cents, 2);
    }
    return format.replace(placeholderRegex, value).replace(/<[^>]+>/g, '');
  }

  /* ---------------- cart helpers ---------------- */
  function getCart() { return fetch(root() + 'cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }); }

  async function rerender() {
    var sectionsToBundle = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } }));
    var cart = await getCart();
    if (sectionsToBundle.length) {
      cart.sections = await fetch(root() + '?sections=' + sectionsToBundle.join(','), { cache: 'no-store' }).then(function (r) { return r.json(); });
    }
    document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'cart:refresh', cart: cart } }));
    return cart;
  }

  function post(path, body) {
    return fetch(root() + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(async function (r) { var j = await r.json(); if (!r.ok) { j.__error = true; } return j; });
  }

  function setDiscounts(codes) {
    // only used by the customer's own code field below
    var uniq = [];
    (codes || []).forEach(function (c) { if (c && uniq.indexOf(c) === -1) uniq.push(c); });
    return post('cart/update.js', { discount: uniq.join(',') });
  }

  function eligibleUnits(cart) {
    return cart.items.reduce(function (n, it) { return n + (OFFER_HANDLES.indexOf(it.handle) !== -1 ? it.quantity : 0); }, 0);
  }
  function lowestEligible(cart) {
    var low = 0;
    cart.items.forEach(function (it) {
      if (OFFER_HANDLES.indexOf(it.handle) === -1) return;
      if (!low || it.original_price < low) low = it.original_price;
    });
    return low;
  }
  function codesOf(cart) { return (cart.discount_codes || []).map(function (c) { return { code: String(c.code).toUpperCase(), applicable: !!c.applicable }; }); }
  function sbSaving(cart) {
    var sum = 0;
    cart.items.forEach(function (it) {
      (it.line_level_discount_allocations || []).forEach(function (a) {
        var t = String(a.discount_application && a.discount_application.title || '').toUpperCase();
        if (t.indexOf(OFFER_TITLE_MATCH) === 0 || t.indexOf(OFFER_TITLE_MATCH) !== -1) sum += a.amount;
      });
    });
    return sum;
  }


  /* ---------------- 1. offer state ----------------
     The saving is a Shopify AUTOMATIC Buy-X-Get-Y discount ("Second bracelet
     30% off"). Shopify applies and removes it by itself from the cart
     contents, so there is no code to attach, nothing to keep in sync, and
     nothing that can eat the customer's own code slot.

     All this does now is read what Shopify decided and say it plainly. If the
     customer's own code was refused because it cannot combine with the offer,
     we tell them rather than leaving a dead code sitting in the cart.
  ------------------------------------------------- */
  async function syncOffer() {
    if (syncing) return;
    syncing = true;
    try {
      var cart = await getCart();
      var saving = sbSaving(cart);
      var codes = codesOf(cart);
      var rejected = codes.filter(function (c) { return !c.applicable; });
      var accepted = codes.filter(function (c) { return c.applicable; });

      if (saving > 0 && rejected.length) {
        // Our offer won. Their code was refused because the two cannot combine.
        lastState = { state: 'code-refused', code: rejected[0].code, saving: saving };
      } else if (saving === 0 && accepted.length) {
        // Their code won and Shopify dropped the offer. Say nothing: their code
        // is applied and the total is right, so there is nothing to explain.
        lastState = { state: 'quiet' };
      } else if (saving > 0) {
        lastState = { state: 'applied', saving: saving };
      } else {
        lastState = null;
      }
      paintState();
    } catch (e) {
      /* never block the cart */
    } finally {
      syncing = false;
    }
  }

  function paintState() {
    var mod = document.querySelector('[data-sb-module]');
    if (!mod || !lastState) return;
    var note = mod.querySelector('[data-sb-note]');
    if (!note) {
      note = document.createElement('p');
      note.className = 'bcart__sb-sub bcart__sb-note-line';
      note.setAttribute('data-sb-note', '');
      mod.appendChild(note);
    }
    mod.classList.remove('bcart__sb--conflict');
    var pending = mod.querySelector('[data-sb-message]');
    if (pending) pending.remove();

    if (lastState.state === 'code-refused') {
      mod.hidden = false;
      mod.classList.add('bcart__sb--conflict');
      note.innerHTML = '<strong>' + lastState.code + '</strong> cannot be combined with this offer.';
    } else {
      note.remove();
    }
  }

  /* ---------------- 2. discount code field ---------------- */
  async function applyCode(code) {
    var msgEl = document.querySelector('[data-code-msg]');
    var cart = await getCart();
    var existing = codesOf(cart).filter(function (c) { return c.code !== CODE; }).map(function (c) { return c.code; });
    var res = await setDiscounts(existing.concat([code]));
    var rc = codesOf(res).find(function (c) { return c.code === code.toUpperCase(); });
    if (msgEl) {
      msgEl.hidden = false;
      if (!rc) { msgEl.textContent = 'That code isn’t valid for this bag.'; msgEl.classList.remove('is-ok'); }
      else if (!rc.applicable) { msgEl.textContent = 'Code added. It will apply once your bag meets its conditions.'; msgEl.classList.remove('is-ok'); }
      else { msgEl.textContent = 'Code applied.'; msgEl.classList.add('is-ok'); }
    }
    writeDisplaced('');
    await rerender();
    syncOffer();
  }

  /* ---------------- 3. protection default-on (test variant) ---------------- */
  async function protectionDefault() {
    var d = drawer();
    if (!d || d.getAttribute('data-protect-default') !== 'true') return;
    try { if (sessionStorage.getItem(PROTECT_OPTOUT_KEY)) return; } catch (e) { return; }
    var cart = await getCart();
    if (!cart.item_count) return;
    var has = cart.items.some(function (it) { return it.variant_id === PROTECTION_VARIANT; });
    var real = cart.items.some(function (it) { return it.variant_id !== PROTECTION_VARIANT; });
    if (has || !real) return;
    await post('cart/add.js', { items: [{ id: PROTECTION_VARIANT, quantity: 1 }] });
    await rerender();
  }

  /* ---------------- 4. complete-the-set stepper ---------------- */
  var bcs = null;
  function initStepper() {
    var el = document.querySelector('[data-bcs]');
    var dataEl = document.querySelector('[data-bcs-products]');
    if (!el || !dataEl || bcs) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    document.body.appendChild(el);
    bcs = {
      el: el, data: data, products: data.products,
      family: 'signature', product: null, variant: null,
      eng: { on: false, font: null, text: '', confirmed: false },
      mode: 'add', lineKey: null, line: null,
      q: function (s) { return el.querySelector(s); }
    };
    bindStepper();
  }

  function familyProducts(fam) { return bcs.products.filter(function (p) { return p.family === fam; }); }

  function openStepper(family, lineForEdit) {
    if (!bcs) initStepper();
    if (!bcs) return;
    bcs.mode = lineForEdit ? 'edit' : 'add';
    bcs.line = lineForEdit || null;
    bcs.lineKey = lineForEdit ? lineForEdit.key : null;
    bcs.eng = { on: false, font: null, text: '', confirmed: false };
    ['font', 'text', 'confirm', 'global'].forEach(clearErr);

    if (bcs.mode === 'edit') {
      bcs.product = bcs.products.find(function (p) { return p.handle === lineForEdit.handle; }) || null;
      bcs.variant = bcs.product ? bcs.product.variants.find(function (v) { return v.id === lineForEdit.variant_id; }) : null;
      var props = lineForEdit.properties || {};
      var txt = props['Engraving text '] || props['_Engraving text '] || '';
      var font = props['Font selection'] || props['_Font selection'] || null;
      bcs.eng = { on: !!txt, font: font, text: txt, confirmed: !!txt };
      bcs.q('[data-bcs-title]').textContent = txt ? 'Edit your engraving' : 'Add engraving';
      bcs.q('[data-bcs-sub]').textContent = (bcs.product ? bcs.product.title + ' ' : '') + (bcs.variant ? bcs.variant.title : '');
      bcs.q('[data-bcs-step="product"]').hidden = true;
      bcs.q('[data-bcs-remove]').hidden = !txt;
      bcs.q('[data-bcs-add]').textContent = txt ? 'Save engraving' : 'Add engraving';
    } else {
      bcs.family = family === 'minimal' ? 'minimal' : 'signature';
      bcs.q('[data-bcs-title]').textContent = 'Choose your second bracelet';
      bcs.q('[data-bcs-sub]').textContent = 'Personalise each bracelet separately.';
      bcs.q('[data-bcs-step="product"]').hidden = false;
      bcs.q('[data-bcs-remove]').hidden = true;
      bcs.q('[data-bcs-add]').textContent = 'Add to bag';
      selectFamily(bcs.family);
    }
    renderEngraving();
    renderPreview();
    renderPrice();
    bcs.el.hidden = false;
    document.documentElement.style.overflow = 'hidden';
  }

  function closeStepper() {
    if (!bcs) return;
    bcs.el.hidden = true;
    document.documentElement.style.overflow = '';
  }

  function selectFamily(fam) {
    bcs.family = fam;
    bcs.el.querySelectorAll('[data-family]').forEach(function (b) { b.classList.toggle('is-selected', b.dataset.family === fam); });
    var list = familyProducts(fam);
    var current = bcs.product && bcs.product.family === fam ? bcs.product : (list.find(function (p) { return p.available; }) || list[0]);
    selectProduct(current);
  }

  function selectProduct(p) {
    bcs.product = p || null;
    var fin = bcs.q('[data-bcs-finish]');
    fin.innerHTML = '';
    familyProducts(bcs.family).forEach(function (fp) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'bcs__chip' + (fp === p ? ' is-selected' : ''); b.textContent = fp.finish;
      if (!fp.available) b.disabled = true;
      b.addEventListener('click', function () { selectProduct(fp); });
      fin.appendChild(b);
    });
    var size = bcs.q('[data-bcs-size]');
    size.innerHTML = '';
    if (!p) { bcs.variant = null; return; }
    var keep = bcs.variant ? bcs.variant.title : null;
    bcs.variant = p.variants.find(function (v) { return v.available && v.title === keep; }) || p.variants.find(function (v) { return v.available; }) || null;
    p.variants.forEach(function (v) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'bcs__chip' + (v === bcs.variant ? ' is-selected' : ''); b.textContent = v.title;
      if (!v.available) b.disabled = true;
      b.addEventListener('click', function () { bcs.variant = v; size.querySelectorAll('.bcs__chip').forEach(function (x) { x.classList.toggle('is-selected', x === b); }); renderPrice(); });
      size.appendChild(b);
    });
    // engraving only on Signature
    if (bcs.family !== 'signature') bcs.eng = { on: false, font: null, text: '', confirmed: false };
    renderEngraving();
    renderPreview();
    renderPrice();
  }

  function renderEngraving() {
    var step = bcs.q('[data-bcs-step="engraving"]');
    var canEngrave = bcs.product && SIGNATURE_HANDLES.indexOf(bcs.product.handle) !== -1;
    step.hidden = !canEngrave;
    if (!canEngrave) return;
    var toggle = bcs.q('[data-bcs-eng]');
    toggle.checked = bcs.eng.on;
    if (bcs.mode === 'edit') { toggle.checked = true; bcs.eng.on = true; toggle.closest('.bcs__engtoggle').style.display = 'none'; }
    else { toggle.closest('.bcs__engtoggle').style.display = ''; }
    bcs.q('[data-bcs-engprice]').textContent = '+' + bcs.data.engravingPriceText;
    bcs.q('[data-bcs-engfields]').hidden = !bcs.eng.on;
    bcs.el.querySelectorAll('[data-bcs-font]').forEach(function (b) { b.classList.toggle('is-selected', b.dataset.bcsFont === bcs.eng.font); });
    var ti = bcs.q('[data-bcs-text]');
    ti.value = bcs.eng.text;
    bcs.q('[data-bcs-count]').textContent = ti.value.length + '/' + bcs.data.maxLength;
    bcs.q('[data-bcs-confirm]').checked = bcs.eng.confirmed;
  }

  function renderPreview() {
    var img = bcs.q('[data-bcs-img]');
    var svg = bcs.q('[data-bcs-svg]');
    if (!bcs.product) return;
    img.src = bcs.product.preview;
    // Normalise how big the bracelet looks between finishes. Copper was shot
    // larger in frame than the others, so it jumped when you flicked through.
    // The SVG gets the same transform or the engraving text drifts off the arc.
    var sc = bcs.product.scale || 1;
    img.style.transform = 'scale(' + sc + ')';
    svg.style.transform = 'scale(' + sc + ')';
    var showText = bcs.eng.on && bcs.product.arc;
    svg.hidden = !showText;
    if (showText) {
      bcs.q('[data-bcs-arc]').setAttribute('d', bcs.product.arc);
      var tp = bcs.q('[data-bcs-textpath]');
      var pt = bcs.q('[data-bcs-prevtext]');
      var text = (bcs.eng.text || '').slice(0, bcs.data.maxLength);
      tp.textContent = text || 'Your text';
      if (text) pt.removeAttribute('data-bcs-empty'); else pt.setAttribute('data-bcs-empty', '');
      pt.style.fontFamily = bcs.eng.font === 'Script' ? "'Snell Roundhand', 'SnellRoundhand', 'Apple Chancery', 'Segoe Script', cursive" : "'Times New Roman', Times, serif";
      tp.setAttribute('startOffset', '50%'); tp.style.textAnchor = 'middle';
    }
  }

  function renderPrice() {
    var was = bcs.q('[data-bcs-was]'), now = bcs.q('[data-bcs-now]'), note = bcs.q('[data-bcs-note]');
    if (!bcs.variant) { was.textContent = ''; now.textContent = ''; note.textContent = ''; return; }
    var d = drawer();
    var price = bcs.variant.price;
    var eng = bcs.eng.on ? bcs.data.engravingPrice : 0;
    if (bcs.mode === 'edit') {
      was.textContent = '';
      now.textContent = bcs.eng.on ? '+' + bcs.data.engravingPriceText + ' engraving' : '';
      note.textContent = '';
      return;
    }
    var fam = bcs.product && bcs.product.family;
    var eligible = fam === 'signature' || fam === 'minimal';
    var save = eligible ? sbAmountFor(price, fam) : 0;
    was.textContent = save ? formatMoney(price + eng) : '';
    now.textContent = formatMoney(price - save + eng);
    // Only ever name the saving. Restating what the engraving costs works
    // against the one number we want them looking at.
    note.textContent = save ? 'You save ' + formatMoney(save) : '';
  }

  function showErr(k) { var e = bcs.q('[data-bcs-error="' + k + '"]'); if (e) e.classList.add('is-shown'); }
  function clearErr(k) { var e = bcs.q('[data-bcs-error="' + k + '"]'); if (e) e.classList.remove('is-shown'); }
  function validEngraving() {
    if (!bcs.eng.on) return true;
    var ok = true;
    if (!bcs.eng.font) { showErr('font'); ok = false; }
    if (!bcs.eng.text.trim()) { showErr('text'); ok = false; }
    if (!bcs.eng.confirmed) { showErr('confirm'); ok = false; }
    return ok;
  }

  // Engraving is charged as its OWN cart line (the real Custom Engraving variant)
  // so Shopify bills the price set for the customer's market. We deliberately
  // do not write the Easify _po:* props any more: that transform FX-converted a
  // hardcoded AUD 20 and mischarged every non-AU market. The visible keys the
  // 3PL reads are unchanged. Bracelet and charge are tied by _engraving_group.
  function newGroup() { return 'eng-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8); }
  function engravingProps(group) {
    var props = {};
    // Hidden (underscore) keys: identical to what every live engraved order
    // already carries, so the order and the 3PL feed keep the same shape.
    props['_Add engraving'] = 'Custom Engraving (' + bcs.data.engravingPriceText + ')';
    props['_Font selection'] = bcs.eng.font;
    props['_Engraving text '] = bcs.eng.text.trim();
    props['_Confirmation '] = CONFIRM_VALUE;
    props['_engraving_group'] = group;
    // Visible summary so the order confirmation email shows the text (see
    // custom-engraving.js). The theme cart already hides this key.
    props['Engraving'] = '\u201C' + bcs.eng.text.trim() + '\u201D \u00B7 ' + bcs.eng.font;
    return props;
  }
  function engravingLine(group) {
    return { id: bcs.data.engravingVariantId, quantity: 1, properties: { _engraving_group: group } };
  }
  function lineGroup(line) { return line && line.properties && line.properties['_engraving_group']; }

  async function submitStepper() {
    var btn = bcs.q('[data-bcs-add]');
    clearErr('global');
    if (!validEngraving()) return;
    if (bcs.mode === 'add' && !bcs.variant) {
      var g = bcs.q('[data-bcs-error="global"]');
      var soldOut = bcs.product && !bcs.product.available;
      g.textContent = soldOut ? 'That finish is sold out. Please choose another.' : 'Please choose a size.';
      g.classList.add('is-shown');
      return;
    }
    btn.setAttribute('aria-busy', 'true');
    try {
      var res;
      if (bcs.mode === 'add') {
        if (bcs.eng.on) {
          var g = newGroup();
          res = await post('cart/add.js', { items: [
            { id: bcs.variant.id, quantity: 1, properties: engravingProps(g) },
            engravingLine(g)
          ] });
        } else {
          res = await post('cart/add.js', { items: [{ id: bcs.variant.id, quantity: 1, properties: {} }] });
        }
      } else {
        // Editing a bracelet already in the bag. If it already carries an
        // engraving charge, keep that charge and just update the text; if it
        // was plain, give it a new group and add the charge line alongside.
        var existing = lineGroup(bcs.line);
        var g2 = existing || newGroup();
        if (existing) {
          // Shopify may have split this bracelet into several lines sharing
          // the group (it does when the saving covers only some units), so
          // the new text goes onto every bracelet line in the group.
          var cartNow = await getCart();
          var braLines = cartNow.items.filter(function (it) { return it.variant_id !== bcs.data.engravingVariantId && lineGroup(it) === existing; });
          if (!braLines.length) braLines = [bcs.line];
          for (var bi = 0; bi < braLines.length; bi++) {
            res = await post('cart/change.js', { id: braLines[bi].key, quantity: braLines[bi].quantity, properties: engravingProps(g2) });
            if (res.__error) break;
          }
        } else {
          res = await post('cart/change.js', { id: bcs.lineKey, quantity: bcs.line.quantity, properties: engravingProps(g2) });
          if (!res.__error) {
            var chg = engravingLine(g2); chg.quantity = bcs.line.quantity;
            res = await post('cart/add.js', { items: [chg] });
          }
        }
      }
      if (res.__error) {
        var ge = bcs.q('[data-bcs-error="global"]'); ge.textContent = res.description || res.message || 'Something went wrong. Please try again.'; ge.classList.add('is-shown');
        return;
      }
      closeStepper();
      await rerender();
      syncOffer();
    } finally {
      btn.removeAttribute('aria-busy');
    }
  }

  async function removeEngravingFromLine() {
    if (!bcs.line) return;
    var btn = bcs.q('[data-bcs-remove]');
    btn.disabled = true;
    try {
      // Remove the engraving charge that belongs to this bracelet, then replace
      // the bracelet with a clean line (change.js keeps stale properties).
      var grp = lineGroup(bcs.line);
      var plainQty = bcs.line.quantity;
      if (grp) {
        var cart = await getCart();
        var charge = cart.items.find(function (it) { return it.variant_id === bcs.data.engravingVariantId && lineGroup(it) === grp; });
        if (charge) await post('cart/change.js', { id: charge.key, quantity: 0 });
        // Every bracelet line in the group loses its engraving, not just the
        // one that was clicked (Shopify may have split the line).
        var grpLines = cart.items.filter(function (it) { return it.variant_id !== bcs.data.engravingVariantId && lineGroup(it) === grp; });
        if (grpLines.length) {
          plainQty = 0;
          for (var gi = 0; gi < grpLines.length; gi++) {
            plainQty += grpLines[gi].quantity;
            if (grpLines[gi].key !== bcs.lineKey) await post('cart/change.js', { id: grpLines[gi].key, quantity: 0 });
          }
        }
      }
      await post('cart/change.js', { id: bcs.lineKey, quantity: 0 });
      await post('cart/add.js', { items: [{ id: bcs.line.variant_id, quantity: plainQty }] });
      closeStepper();
      await rerender();
      syncOffer();
    } finally { btn.disabled = false; }
  }

  function bindStepper() {
    var el = bcs.el;
    el.querySelectorAll('[data-bcs-close]').forEach(function (b) { b.addEventListener('click', closeStepper); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !el.hidden) closeStepper(); });
    el.querySelectorAll('[data-family]').forEach(function (b) { b.addEventListener('click', function () { selectFamily(b.dataset.family); }); });
    bcs.q('[data-bcs-eng]').addEventListener('change', function (e) { bcs.eng.on = e.target.checked; renderEngraving(); renderPreview(); renderPrice(); });
    el.querySelectorAll('[data-bcs-font]').forEach(function (b) { b.addEventListener('click', function () { bcs.eng.font = b.dataset.bcsFont; clearErr('font'); renderEngraving(); renderPreview(); }); });
    bcs.q('[data-bcs-text]').addEventListener('input', function (e) { bcs.eng.text = e.target.value; bcs.q('[data-bcs-count]').textContent = e.target.value.length + '/' + bcs.data.maxLength; clearErr('text'); renderPreview(); });
    bcs.q('[data-bcs-confirm]').addEventListener('change', function (e) { bcs.eng.confirmed = e.target.checked; clearErr('confirm'); });
    bcs.q('[data-bcs-add]').addEventListener('click', submitStepper);
    bcs.q('[data-bcs-remove]').addEventListener('click', removeEngravingFromLine);
  }

  /* ---------------- delegated events ---------------- */
  document.addEventListener('click', function (e) {
    var co = e.target.closest && e.target.closest('.bcart__checkout');
    if (co && syncing) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);

  document.addEventListener('click', async function (e) {
    var t = e.target.closest && e.target.closest('[data-bcs-open], [data-bcart-edit-engraving], [data-bcart-add-engraving], [data-code-toggle], [data-code-apply], [data-protect-toggle]');
    if (!t) return;
    if (t.hasAttribute('data-bcs-open')) { e.preventDefault(); openStepper(t.getAttribute('data-bcs-open')); return; }
    if (t.hasAttribute('data-bcart-edit-engraving') || t.hasAttribute('data-bcart-add-engraving')) {
      e.preventDefault();
      var key = t.getAttribute('data-bcart-edit-engraving') || t.getAttribute('data-bcart-add-engraving');
      var cart = await getCart();
      var line = cart.items.find(function (it) { return it.key === key; });
      if (line) openStepper(null, line);
      return;
    }
    if (t.hasAttribute('data-code-toggle')) { e.preventDefault(); var f = document.querySelector('[data-code-form]'); if (f) { f.hidden = !f.hidden; if (!f.hidden) { var i = f.querySelector('input'); i && i.focus(); } } return; }
    if (t.hasAttribute('data-code-apply')) { e.preventDefault(); var inp = document.querySelector('[data-code-input]'); var code = inp && inp.value.trim(); if (code) { t.disabled = true; try { await applyCode(code); } finally { t.disabled = false; } } return; }
    if (t.hasAttribute('data-protect-toggle')) {
      // boobie-cart.js does the add/remove; we only remember an explicit opt-out for the pre-selected variant.
      var turningOff = t.classList.contains('is-on') || t.classList.contains('bcart__protect-remove');
      try { if (turningOff) sessionStorage.setItem(PROTECT_OPTOUT_KEY, '1'); else sessionStorage.removeItem(PROTECT_OPTOUT_KEY); } catch (err) { /* quiet */ }
      if (t.classList.contains('bcart__protect-remove')) {
        e.preventDefault();
        var tg = document.querySelector('.bcart__protect-toggle');
        if (tg) tg.click();
      }
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target && e.target.hasAttribute && e.target.hasAttribute('data-code-input')) {
      e.preventDefault(); var b = document.querySelector('[data-code-apply]'); b && b.click();
    }
  });

  /* ---------------- triggers ---------------- */
  var debounce;
  function scheduleSync() { clearTimeout(debounce); debounce = setTimeout(function () { syncOffer(); paintState(); }, 350); }
  document.addEventListener('cart:change', scheduleSync);
  document.addEventListener('cart:refresh', scheduleSync);
  document.addEventListener('cart:change', function () { setTimeout(paintState, 50); });

  function boot() { initStepper(); syncOffer(); protectionDefault(); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  new MutationObserver(function () { if (!bcs) initStepper(); }).observe(document.documentElement, { childList: true, subtree: true });
})();
